import { createStoreModule } from '@/_core/fluxstore';
import { IAction } from '@/_core/fluxstore/types';
import { SnackbarState } from './types';

const initState = () => {
    return new SnackbarState();
};

export const useAppSnackbarModule = createStoreModule<SnackbarState, IAction<SnackbarState>>(initState, 'app-snackbar');
